import { colors } from '@atlaskit/theme';
import { getTokenValue } from '@atlaskit/tokens';

export const X_AXIS_TYPE = 'category';
export const Y_AXIS_TYPE = 'value';
export const AXIS_COLOR = getTokenValue('color.border', colors.N40);
export const AXIS_LABEL_COLOR = getTokenValue('color.text.subtle', colors.N300);
export const TOOL_TIP_TRIGGER = 'axis';
